import React, {useState, useEffect} from 'react';

import { InputGroup } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import AgGridReactEx from "@app/components/AgGridReactEx";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

import NurseryFormTable from './NurseryFormTable';

import * as Constant from '@app/Constant.js';
import axios from '@app/lib/axios';
import * as commonData from "@app/lib/common_data";



const SearchNurseryModal = ({show, setShow, selectData}) => {
    const [list, setList] = useState([]);
    const [onSearching, setOnSearching] = useState(false);

    const [codes, setCodes] = useState([]);
    const [sidoList, setSidoList] = useState([]);
    const [sigunguList, setSigunguList] = useState([]);
    const [searchParam, setSearchParam] = useState({
        sido: '',
        sigungu: '',
        type: '',
        name: ''
    });

    const [requestModal, showRequestModal] = useState(false);

    useEffect(() => {
        if(codes.length <= 0) {
            getLocCodes();
        }
        return () => {};
    }, [show]);

    let gridApi = null;

    const listColumn = [
        {
            headerName: "no",
            headerClass: 'bg-dark text-light',
            sortable: false,
            minWidth : 50,
            width : 50,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return params.rowIndex +1;
            }
        },
        {
            headerName: "구분",
            headerClass: 'bg-dark text-light',
            field: "type",
            sortable: true,
            minWidth : 80,
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return (params.value  === 'S' ? '유치원' : '어린이집')
            }
        },
        {
            headerName: "원명",
            headerClass: 'bg-dark text-light',
            field: "name",
            sortable: true,
            minWidth : 180,
            width : 180,
            resizable : true,
            filter: false
        },
        {
            headerName: "원장",
            headerClass: 'bg-dark text-light',
            field: "director_name",
            sortable: true,
            minWidth : 70,
            width : 70,
            resizable : true,
            cellClass: "text-center",
            filter: false
        },
        {
            headerName: "지역",
            headerClass: 'bg-dark text-light',
            field: "address",
            sortable: false,
            minWidth : 250,
            width : 250,
            resizable : true,
            filter: false
        },
        {
            headerName: "상태",
            headerClass: 'bg-dark text-light',
            field: "status",
            sortable: false,
            minWidth : 60,
            width : 60,
            resizable : true,
            filter: false,
            cellRenderer: (params) => {
                return (params.value  === 'active' ? '정상' : params.value);
            }
        },
        {
            headerName: "계약 등록",
            headerClass: 'bg-dark text-light',
            field: "id",
            sortable: false,
            minWidth : 80,
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return '<button class="btn btn-primary font-12" onClick="dataCallback('+ params.value +')" style="padding: 1px 3px">계약 등록</button>'
            }
        }
    ];

    const getLocCodes = () => {
		commonData.getLocCodes(axios, (err, result) => {
			if(!err) {
                setCodes(result);
                if (result.length > 0) {
                    setSidoList(result);
                    setSigunguList(result[0].child);
                    const param = {...searchParam};
                    param.sido = result[0].code;
                    param.sigungu = result[0].child[0].code;
                    setSearchParam(param);
                }
            }
        });
    };

    const onGridReady = (params) => {
        gridApi = params.api;
        params.api.sizeColumnsToFit();
    }

    const onChangeSido = (value) => {
        if(codes && sidoList) {
            const param = {...searchParam};
            param.sido = value;
            const sido = sidoList.filter((sido) => {
                return ''+sido.code === value;
            })
            if(sido && sido.length >= 1) {
                setSigunguList(sido[0].child);
                param.sigungu = sido[0].child[0].code;
            }
            setSearchParam(param);
        }
    }
    
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            searchNursery();
        }
    };

    const searchNursery = () => {
        if(!searchParam.sido) {
            alert('지역(시/도, 시/군/구)은 필수로 선택해 주세요.');
            return;
        }

        if(!searchParam.sigungu) {
            alert('지역(시/도, 시/군/구)은 필수로 선택해 주세요.');
            return;
        }
        setOnSearching(true);
        axios({
          method: "get",
          url: `${Constant.API_DOMAIN}/api/nursery/search/SA/?type=${searchParam.type}&siDo=${searchParam.sido}&siGunGu=${searchParam.sigungu}&name=${searchParam.name}`
        })
        .then(res => {

            const result = res.data.result.list;
            if(gridApi) gridApi.sizeColumnsToFit();
            setList(result);
            setOnSearching(false);
          })
        .catch(error => {
            console.log(error);
            setOnSearching(false);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
    }
    const onRowClicked = (params) => {
        if (params.api.getFocusedCell()) {
            return onDetail(params.data.id);
        }
    };

    const onDetail = (nurseryId) => {
        const data = list.filter((n) => {
            return n.id === nurseryId
        });

        if(selectData) {
            const _data = data[0];
            _data.sido = searchParam.sido;
            _data.sigungu = searchParam.sigungu;
            // console.log(_data);
            selectData(_data);
            // setShow(false);
        } else{
            console.log(data[0]);
        }
    };

	return (
        <>
            <button
                className="btn btn-brand btn-block btn-rounded"
                onClick={() => {
                    setShow(true);
                }}
            >
                <i className="fas fa-plus-circle mr-2" />
                신규 원 등록
            </button>
    		<Modal
                size='lg'
                show={show}
                onHide={() => setShow(false)}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        계약 등록할 원 불러오기
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12">
                            <div className="page-header">
                                <h4 className="pageheader-title">유치원 어린이집 통합 DB 조회</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-1 mb-2">
                            <label htmlFor="edit_nursery">
                                시/도
                            </label>
                            <select
                                className="form-control mt-2"
                                onChange={(e) => onChangeSido(e.target.value)}
                                value={searchParam.sido}
                                disabled={onSearching}
                            >
                                {sidoList && (
                                    sidoList.map((sido, idx) => {
                                        return (<option value={sido.code} key={`select-sido-${idx}`}>{sido.name}</option>);
                                    })
                                )}
                            </select>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-1 mb-2">
                            <label htmlFor="edit_nursery">
                                시/군/구
                            </label>
                            <select
                                className="form-control mt-2"
                                value={searchParam.sigungu}
                                disabled={onSearching}
                                onChange={(e) => {
                                    const param = {...searchParam};
                                    param.sigungu = e.target.value;
                                    setSearchParam(param);
                                }}
                            >
                                {sigunguList && (
                                    sigunguList.map((sigungu, idx) => {
                                        return (<option value={sigungu.code} key={`select-sigungu-${idx}`}>{sigungu.name}</option>);
                                    })
                                )}
                            </select>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        name="type"
                                        value=""
                                        className="custom-control-input"
                                        checked={searchParam.type === ''}
                                        disabled={onSearching}
                                        onChange={(e) => {
                                            const param = {...searchParam};
                                            param.type = e.target.value;
                                            setSearchParam(param);
                                        }}
                                    />
                                    <span className="custom-control-label">전체</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        name="type"
                                        value="S"
                                        className="custom-control-input"
                                        checked={searchParam.type === 'S'}
                                        disabled={onSearching}
                                        onChange={(e) => {
                                            const param = {...searchParam};
                                            param.type = e.target.value;
                                            setSearchParam(param);
                                        }}
                                    />
                                    <span className="custom-control-label">유치원</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        name="type"
                                        value="A"
                                        checked={searchParam.type === 'A'}
                                        className="custom-control-input"
                                        disabled={onSearching}
                                        onChange={(e) => {
                                            const param = {...searchParam};
                                            param.type = e.target.value;
                                            setSearchParam(param);
                                        }}
                                    />
                                    <span className="custom-control-label">어린이집</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        name="type"
                                        value="X"
                                        checked={searchParam.type === 'X'}
                                        className="custom-control-input"
                                        disabled={onSearching}
                                        onChange={(e) => {
                                            const param = {...searchParam};
                                            param.type = e.target.value;
                                            setSearchParam(param);
                                        }}
                                    />
                                    <span className="custom-control-label">기타</span>
                                </label>
                            </div>
                            <InputGroup className="input-group my-group">
                                <input
                                    className="form-control"
                                    type="text"
                                    value={searchParam.name}
                                    disabled={onSearching}
                                    onChange={(e) => {
                                        const param = {...searchParam};
                                        param.name = e.target.value;
                                        setSearchParam(param);
                                    }}
                                    onKeyPress={handleKeyPress}
                                />
                                <InputGroup.Append>
                                    <button
                                        className="btn btn-primary"
                                        onClick={searchNursery}
                                        disabled={onSearching}
                                    >
                                        {onSearching ? (<i class="fas fa-spinner"></i>) : '검색'}
                                    </button>
                                </InputGroup.Append>
                            </InputGroup>
                        </div>
                    </div>
                    <div className="row pt-2">
                        <div className="col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12">
                            <h5>조회 결과 : 총 {list.length}건</h5>
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12  ag-theme-balham" style={{height: `300px`}}>
                            <AgGridReactEx
                              onGridReady={onGridReady}
                              columnDefs={listColumn}
                              rowData={list}
                              onRowClicked={onRowClicked}
                              rowSelection="single"
                              overlayNoRowsTemplate={`<span>검색된 원 목록이 없습니다.</span>`}
                              height={300}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <h5 className="text-right mt-1 pt-1">* 찾으시는 원이 검색에 나오지 않나요?</h5>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                            <button
                                className="btn btn-block btn-rounded btn-brand"
                                onClick={() => {
                                    showRequestModal(true);
                                }}
                            >
                                원 등록 요청하기
                            </button>
                            <RequestNurseryInfo
                                show={requestModal}
                                onHide={() => {
                                    showRequestModal(false)
                                }}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
	);
}


const RequestNurseryInfo = ({show, onHide}) => {
    const [doingSubmit, setDoingSubmit] = useState(false);
    useEffect(() => {
        return () => {};
    }, [show]);

    const requestNursery = () => {
        const nursery = window.getNurseryFormData();
        if(!nursery.name || !nursery.type || !nursery.sub_type || !nursery.ceo || !nursery.director || !nursery.sido || !nursery.sigungu || !nursery.addr
            || !nursery.tel
            ) {
            alert('입력이 누락된 항목이 있습니다.\n모든 항목에 정보를 입력하신 후 \n원 등록 요청하기 버튼을 눌러주세요.');
            return;
        }
        setDoingSubmit(true);
        if(window.confirm('해당 원을 원 통합 DB에 등록 요청하시겠습니까?')) {
            axios({
              method: "post",
              url: `${Constant.API_DOMAIN}/api/nursery/request/${localStorage['login_branch_id'] || 0}`,
              data: nursery
            })
            .then(res => {
                alert(`${nursery.name} 이(가) 통합 DB에 등록 요청 완료 되었습니다.\n* 통합 DB에 등록이 완료되어야 계약을 진행할 수 있습니다. 급한 건인 경우 본사로 연락 주시기 바랍니다.`);
                document.location.reload();
              })
            .catch(error => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setDoingSubmit(false);
            });
        } else {
            setDoingSubmit(false);
        }
    }

    return (
        <Modal
            size='lg'
            show={show}
            onHide={() => {
                if(window.confirm('원 등록 요청을 취소 하시겠습니까?')) onHide();
            }}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    유치원·어린이집 통합DB 등록 요청
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container bg-success-light p-2 mb-2" style={{borderRadius: '10px'}}>
                    <h5 className="text-danger mb-1">* 해당 화면은 계약 정보를 입력하는 화면이 아닙니다.</h5>
                    <p >유치원·어린이집 통합정보공시 DB에서 정보를 찾을 수 없는 원에 대해 아래 정보로 등록 요청을 본사로 보내는 화면이므로 참고 바랍니다.</p>
                </div>
                <NurseryFormTable />
                <div className="container text-center pt-3">
                    <button
                        className="btn btn-brand btn-rounded w80"
                        onClick={requestNursery}
                        disabled={doingSubmit}
                    >
                        원 등록 요청하기
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default SearchNurseryModal;